export const redirectTo = (param) => {
    return window.location.href = param;
}